import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';

import Question, {
  QuestionProps,
} from './Question';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export enum QuestionnaireInputType {
  TextArea = 'textarea',
  RichText = 'richtext',
}

export interface QuestionnaireProps
  extends Pick<QuestionProps, 'onUpdate' | 'onDelete' | 'onFocus'> {
  data: QuestionProps[];
  maxQuestions: number;
  onAdd: () => void;
  inputType?: QuestionnaireInputType;
  labelClassName?: string;
  deleteButtonClassName?: string;
  addButtonClassName?: string;
  addButtonTextClassName?: string;
  inputClassName?: string;
}

export function Questionnaire({
  data,
  maxQuestions,
  onAdd,
  onUpdate,
  onDelete,
  onFocus,
  inputType,
  labelClassName,
  deleteButtonClassName,
  addButtonClassName,
  addButtonTextClassName,
  inputClassName,
}: QuestionnaireProps) {

  return (
    <>
      {data.map((question, index) => (
        <Question
          key={index}
          number={index + 1}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onFocus={onFocus}
          inputType={inputType}
          labelClassName={labelClassName}
          deleteButtonClassName={deleteButtonClassName}
          inputClassName={inputClassName}
          {...question}
        />
      ))}
      {data.length < maxQuestions && (
        <Button
          variant={ButtonVariant.SecondaryWhite}
          className={cx(addButtonClassName, 'v2-w-full')}
          onClick={onAdd}
        >
          <div
            className={cx(
              addButtonTextClassName,
              'v2-flex v2-justify-center v2-items-center v2-gap-x-3'
            )}
          >
            <FontAwesomeIcon className='v2-text-2xl' icon={faPlus} />
            Add a question
          </div>
        </Button>
      )}
    </>
  );
}
